import { Arrow } from "@antv/g6/es";

const lineColor = {
  // default: "#B4B8C4",
  default: "rgba(146, 156, 178, 1)",
  active: "#4A70FF",
  updating: "#4A70FF",
  error: "#E54545",
};

export const g6Config = {
  modes: {
    default: [
      {
        type: "drag-node",
        shouldBegin({ target }) {
          // 如果从source bullet开始拖拽,是新建edge
          return !["source-hot-area", "anchor-point"].includes(
            target.get("name"),
          );
        },
      },
      "drag-group",
      {
        type: "drag-canvas",
        enableOptimize: false,
        scalableRange: -0.4,
        // ... 其他配置
      },
      "click-select",
      {
        type: "zoom-canvas",
        sensitivity: 1,
        minZoom: 0.2,
        animate: false,
        // enableOptimize: true,
        maxZoom: 2,
        shouldUpdate: (e) => {
          e.preventDefault();
          // 按住ctrl/command缩放
          return e.ctrlKey || e.metaKey;
        },
      },
      // 'activate-relations',
      "click-create-edge",
      "drag-create-edge",
      "drag-update-edge",
      "drag-create-node",
      "delete-node",
      "node-button-click",
      "delete-edge",
      "node-click",
    ],
    // 切换编辑模式，暂未使用
    custom: [
      "drag-canvas",
      "drag-create-node",
      "node-button-click",
      "click-create-edge",
      {
        type: "zoom-canvas",
        sensitivity: 1,
        minZoom: 0.2,
        maxZoom: 2,
        shouldUpdate: (e) => {
          e.preventDefault();
          // 按住ctrl/command缩放
          return e.ctrlKey || e.metaKey;
        },
      },
      "delete-edge",
    ],
  },
  groupByTypes: true,
  minZoom: 0.2,
  maxZoom: 2,
  renderer: "canvas",
  animate: true,
  animateCfg: {
    duration: 400,
    easing: "easePolyInOut",
  },
  layout: {
    type: "dagre",
    rankdir: "TB", // 可选，默认为图的中心
    // align: undefined, // 可选
    // 'UL'：对齐到左上角；
    // 'UR'：对齐到右上角；
    // 'DL'：对齐到左下角；
    // 'DR'：对齐到右下角；
    // undefined：默认，中间对齐。
    // align: "UL", // 可选
    nodesep: 80, // 可选
    edgesep: 50,
    // nodesepFunc: (node) => {
    // const arr = [100, 120, 140];
    // return arr[_.random(0, arr.length - 1)];
    // },
    ranksep: 50,
    // ranksepFunc: () => {
    //   const arr = [40, 50, 60];
    //   return arr[_.random(0, arr.length - 1)];
    // },
  },
  defaultNode: {
    type: "custom-node",
    // label: "node-label",
    labelCfg: {
      position: "bottom",
      offset: 24,
      style: {
        fill: "#000",
        lineWidth: 0,
        fontSize: 12,
        background: {
          // 背景填充色
          fill: "#ffffff",
          // 背景的边框色
          stroke: "transparent",
          // 背景的边框间距
          padding: [8, 8, 8, 8],
          radius: 6,
        },
      },
    },
  },
  // https://g6.antv.antgroup.com/manual/middle/elements/edges/default-edge
  defaultEdge: {
    // line ：直线，不支持控制点；
    // polyline ：折线，支持多个控制点；
    // arc ：圆弧线；
    // quadratic ：二阶贝塞尔曲线；
    // cubic ：三阶贝塞尔曲线；
    // cubic-vertical ：垂直方向的三阶贝塞尔曲线，不考虑用户从外部传入的控制点；
    // cubic-horizontal ：水平方向的三阶贝塞尔曲线，不考虑用户从外部传入的控制点；
    // loop ：自环。
    // cubic-auto ：自建 cubic。
    type: "polyline",

    // cubic
    // quadratic
    // cubic-vertical
    // cubic-horizontal 等贝塞尔曲线特有
    curveOffset: 60,

    // cubic-vertical
    // cubic-horizontal 边特有
    minCurveOffset: 0,
    style: {
      stroke: lineColor.default,
      // DESC: 连线粗细
      lineWidth: 2,
      // offset 一定要比 radius 大
      offset: 40, // 拐弯处距离节点最小距离
      // radius: 0, // 拐弯处的圆角弧度，若不设置则为直角
      radius: 10, // 拐弯处的圆角弧度，若不设置则为直角
      // https://g6.antv.antgroup.com/api/shape-properties#lineappendwidth
      lineAppendWidth: 14,
      // startArrow: true,
      endArrow: {
        // path: G6.Arrow.circle(1.5),
        fill: lineColor.default,
        lineWidth: 1,
        path: Arrow.triangle(13, 14, 0),
        // path: G6.Arrow.vee(10, 20, 10),
        // d: 10,
        // stroke: "#4A70FF",
        // path: "M 0,0 L 6,4 L 6,-4 Z",
        d: 7,
        // d: 10,
      },
      // https://g6.antv.antgroup.com/manual/middle/elements/edges/arrow#%E5%90%84%E7%AE%AD%E5%A4%B4%E6%A6%82%E8%A7%88
      // 起点箭头
      startArrow: false,
      // startArrow: {
      //   fill: "rgba(146, 156, 178, 0.3)",
      //   path: G6.Arrow.circle(1, 0),
      //   // path: G6.Arrow.triangle(10, 20, 25),
      //   lineWidth: 1,
      //   stroke: "#4A70FF",
      //   d: 1,
      // },
      cursor: "pointer",
    },

    labelCfg: {
      style: {
        // 文字颜色
        fill: "#1C66E5",
        fontSize: 12,
        offset: 10,
        background: {
          // 背景填充色
          fill: "#EBF2FF",
          // 背景的边框色
          stroke: "transparent",
          // 背景的边框间距
          padding: [10, 10, 10, 10],
          radius: 6,
        },
      },
      // autoRotate: true,
    },
    routeCfg: {
      // 路由计算参数
      gridSize: 30, // 指定精度
    },
  },
  // https://g6.antv.antgroup.com/api/graph#graphoptionsedgestatestyles
  // packages/core/src/global.ts
  edgeStateStyles: {
    active: {
      lineWidth: 2,
    },
    updating: {
      stroke: lineColor.updating,
    },
    error: {
      stroke: lineColor.error,
    },
  },
};
